<template>
    <div class="flex bg-gray-100" style="height: 350px;padding: 5px;">
        <Dropzone
            ref-key="dropzoneUploadRef"
            :options="dropzoneOptions"
            class="h-full "
            style="border: 0; flex: 1 1 40%; "
        >
            <div class="text-md font-medium">
                <UploadIcon /> <div>คลิกเพื่อเลือกไฟล์หรือลากไฟล์มาวางที่นี่</div>
            </div>
        </Dropzone>
        <div id="preview-template" style="flex: 1 1 60%; height: 100%; overflow: hidden; overflow-y:auto;">
        </div>
        <modal-layout id="imageDesc" v-model="imageDescription" class="grid content-center" :isSaveOnly="true" :isDone="isDone" headerTitle="เพิ่มคำอธิบายรูปภาพ">
            <div v-for="(item,idx) in tempImage" :key="idx">
                <div class="dz-preview mb-2">
                    <div class="dz-image" style="background: #f2f3f3;border-radius: 6px;">
                        <img :src="item.image_url" />
                    </div>
                    <div class="dz-details">
                        <textarea placeholder="คำอธิบายรูปภาพ" class="form-control" style="resize: none; height: 100%;" v-model="tempImage[idx].description"/>
                    </div>
                </div>
            </div>
        </modal-layout>
        <imagePreview :index="currentImgPreviewIndex" :images="listAllUploadImage" @close="currentImgPreviewIndex = null"/>
    </div>
</template>

<script setup>
import modalLayout from "@/components/base/custom-modal/CustomModalLayout.vue"
import {ref,reactive,watch, nextTick} from "vue"
import Swal from "sweetalert2";
import {compressImage} from "@/utils/minio"
import imagePreview from "@/components/image-preview/index.vue"

const swalCustom = Swal.mixin({
  customClass: {
    confirmButton: 'btn btn-primary m-1',
    cancelButton: 'btn btn-outline-secondary m-1'
  },
  buttonsStyling: false
})

const props = defineProps({
    dataInfo:{
        type: Object
    },
    uploadCancelEvent: Boolean
})
const imageDescription = ref(false)
const isDone = ref(false)
const isError = ref(false)
const fileErrorMsg = ref({})
// const save = ref(false)
// const formImage = ref({
//     description: ""
// })
const tempImage = ref([]) //list image for description modal
const tempImage_length = ref(0) //count for description modal
const imageUploadList = ref([])//send to api
const currentImgPreviewIndex = ref(null)
const listAllUploadImage = ref([])//list preview image
// const count_img = ref(0)
// var countFileUploaded = 0
// var tempCountImgAdded = 0
var tempImageUploading = []//list image added to preview template

const emit = defineEmits(["button-active-status","complete-upload"])
const dropzoneOptions = reactive(
    {
        url: `${process.env.VUE_APP_BASE_API}bucket/mso-logbook/images/${props.dataInfo.hh_id}/${props.dataInfo._id}`,
        // url: 'https://httpbin.org/post',
        contentType: false,
        processData: false,
        thumbnailWidth: 150,
        createImageThumbnails: true,
        // addRemoveLinks: true,
        maxFilesize: 20, // MiB
        // maxFiles: 2,
        uploadMultiple: true,
        parallelUploads: 2,
        autoProcessQueue: false, //use with processQueue()
        uploadMultiple: true,
        acceptedFiles: 'image/*',
        dictFallbackMessage: "Your browser does not support drag'n'drop file uploads.",
        dictFileTooBig: "ขนาดไฟล์เกินที่กำหนด({{filesize}}MiB). ขนาดไฟล์ที่รองรับสูงสุด: {{maxFilesize}}MiB.",
        dictInvalidFileType: "ไม่รองรับสกุลไฟล์ที่เลือก",
        dictResponseError: "Server responded with {{statusCode}} code.",
        dictCancelUpload: "Cancel upload",
        dictUploadCanceled: "Upload canceled.",
        dictCancelUploadConfirmation: "ต้องการยกเลิกการอัพโหลดไฟล์ ?",
        previewTemplate:`<div class="dz-preview dz-file-preview m-2">\
                <div class="dz-image">\
                    <img class="thumbnail" data-dz-thumbnail />\
                    <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>\
                    <div class="dz-success-mark"></div>\
                    <div class="dz-error-mark"><span></span></div>\
                    <div class="dz-error-message"><span data-dz-errormessage></span></div>\
                </div>\
                <div class="dz-details">\
                    <div class="image-description"><span></span></div>\
                    <div class="dz-size"><span data-dz-size="" class="image-size"></span></div>\
                    <img class="image-remove" src="${require('../../assets/images/icon/x.svg')}" alt="*" data-dz-remove>\
                </div>\
            </div>`,
        previewsContainer: "#preview-template",
        errormultiple: function (file, message, xhr) {
            if (xhr && xhr.status === 503) {
        tempImage.value = []
        tempImageUploading = [] 
        
        swalCustom.fire({
            icon: "warning",
            text: `บันทึกไฟล์รูปภาพไม่สำเร็จ`,
            confirmButtonText: "ปิด"

            // html: `<div class="mb-2 text-xl flex justify-center">
            //         <img class="mr-1" src="${require('../../assets/images/icon/alert-circle.svg')}"/> 
            //         เกิดข้อผิดพลาด!
            //        </div>
            //        <div class="text-base mb-1">
            //         ระบบไม่สามารถอัปโหลดไฟล์ได้ในขณะนี้<br>
            //         กรุณาลองใหม่อีกครั้งภายหลัง (Error 503)
            //        </div>`
        }).then(()=>{
            const modalElement = document.getElementById("tracking-process");
        if (modalElement) {
                imageDescription.value = false
        isDone.value = false
        emit("button-active-status", true)
            const cancelButton = modalElement.querySelector('.btn-secondary') || 
                                modalElement.querySelector('[data-dismiss="modal"]') ||
                                modalElement.querySelector('.close');
            
            if (cancelButton) {
                cancelButton.click();
            }
        }
        })
        return;
    }
            imageDescription.value = false
            isError.value = true
            fileErrorMsg.value[file[0].name] = message
        },
        renameFile: function (file) {
            return file.renameFile = `plan-${_uuidv4()}.${file.name.split('.').pop()}`;
        },
        removedfile: function(file){
            if (file.previewElement != null && file.previewElement.parentNode != null) {
                file.previewElement.parentNode.removeChild(file.previewElement);
                tempImage_length.value -= 1
                let idx_desc = imageUploadList.value.findIndex(({file_name})=>file_name==file.renameFile)
                imageUploadList.value.splice(idx_desc,1)

            }
        },
        init: function() {
            var myDropZone = this
            this.on("addedfiles", async function(file) {
                if(isError.value){
                    var html_content = ""
                    for (const [key, value] of Object.entries(fileErrorMsg.value)) {
                        html_content += `<tr><td>${key}</td><td>${value}</td></tr>`
                    }
                    swalCustom.fire({
                        // title: "เกิดข้อผิดพลาด!",
                        confirmButtonText: "ปิด",
                        html: `<div class="mb-2 text-xl flex justify-center"><img class="mr-1" src="${require('../../assets/images/icon/alert-circle.svg')}"/> เกิดข้อผิดพลาด!</div>
                        <div class="text-base mb-1">ไฟล์เหล่านี้จะไม่ถูกอัพโหลด</div>
                        <table id="error-table" border=1>
                                <thead>
                                    <tr>
                                        <th width="40%">ชื่อไฟล์</th>
                                        <th>รายละเอียด</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    ${html_content}
                                </tbody>
                            </table>`
                    }).then(()=>{
                        fileErrorMsg.value = {}
                        isError.value = false
                    })
                }
                var error_count = 0
                for(let i=0; i< file.length;i++){
                    var image = new Image();
                    if(file[i].status == "error"){
                        error_count += 1
                        //error then remove
                        if (file[i].previewElement != null && file[i].previewElement.parentNode != null) {
                            file[i].previewElement.parentNode.removeChild(file[i].previewElement);
                        }
                    }else{
                        let compress_img = await compressImage(file[i])
                        //set renameFile to file obj compress_img
                        compress_img.renameFile = file[i].renameFile
                        image.src = URL.createObjectURL(compress_img);
                        let file_size = myDropZone.filesize(compress_img.size)
                        tempImage.value.push({image_url: image.src, image_size: file_size, compress_img})
                    }
                }
                // console.log("err",error_count,file.length);
                if(error_count != file.length){
                    emit("button-active-status", false)
                    imageDescription.value = true
                    const modalConfirm = document.getElementById("imageDesc").getElementsByClassName("btn-primary")[0]
                    modalConfirm.addEventListener("click", function () {
                        var elm = document.getElementsByClassName("image-description")
                        var imgElm = document.getElementsByClassName("dz-image")
                        var elmImgSize = document.getElementsByClassName("image-size")
                        tempImageUploading = [...tempImageUploading,...tempImage.value]

                        for(let i = 0; i < tempImage.value.length; i++){
                            var description_inx = tempImage_length.value != 0 ? i+tempImage_length.value : i
                            elm[description_inx].innerHTML = tempImage.value[i]?.description ? tempImage.value[i].description : ""
                            elmImgSize[description_inx].innerHTML = tempImage.value[i]?.image_size ? tempImage.value[i].image_size : ""
                            //set src to data-src attr for preview org image
                            imgElm[description_inx].setAttribute("data-src",tempImage.value[i].image_url)
                        }
                        imageDescription.value = false
                        isDone.value = true
                        tempImage_length.value += tempImage.value.length
                        tempImage.value = []
                        myDropZone.processQueue()
                    })
                }
           }),
           this.on("successmultiple", function(file, response) {
                for(let i of file){
                    let idx_desc = tempImageUploading.findIndex(({compress_img})=>compress_img.name==i.name)
                    imageUploadList.value.push({
                        "img_label": tempImageUploading[idx_desc]?.description ? tempImageUploading[idx_desc].description : "",
                        "file_name": tempImageUploading[idx_desc].compress_img.renameFile,
                        "img_url": `${process.env.VUE_APP_BASE_API}bucket/mso-logbook/images/${props.dataInfo.hh_id}/${props.dataInfo._id}/${tempImageUploading[idx_desc].compress_img.renameFile}`,
                        "img_size": tempImageUploading[idx_desc]?.image_size ? tempImageUploading[idx_desc].image_size.replace( /(<([^>]+)>)/ig, '') : "",
                        "created_date": new Date().toISOString()
                    })
                }
                // console.log("imageUploadList ",imageUploadList.value);
            });
            this.on("queuecomplete", function(){
                tempImageUploading = []
                myDropZone.options.autoProcessQueue = false;//when queue complete set to false to prevent auto upload before enter description when add more new file
                emit("button-active-status", true)
                emit("complete-upload", imageUploadList.value)
            })
            this.on("sendingmultiple", async function(file, xhr, formData) {
                //set auto process queue to process file in queue
                myDropZone.options.autoProcessQueue = true;
                //get all image preview
                const listItems = Array.from(document.querySelectorAll(".dz-preview"));
                listAllUploadImage.value = []
                // add click event listener for each collection item
                listItems.forEach( ( button, index ) =>
                {
                    listAllUploadImage.value.push(
                        {
                            image_url: listItems[index].getElementsByClassName("dz-image")[0].getAttribute("data-src"),
                            description: listItems[index].getElementsByClassName("image-description")[0].textContent
                        }
                    )
                    button.getElementsByClassName("dz-image")[0].addEventListener("click", (evt) =>
                    {
                        currentImgPreviewIndex.value = index //set current index clicked
                    });
                });
            })
        },
        transformFile: async function (file, done){
            //resize image here
            let compress_img = await compressImage(file)
            file = compress_img
            return done(file);

        },
    }
)
var _uuidv4 = function() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function(c) {
    return (
      c ^
      ((window.crypto || window.msCrypto).getRandomValues(
        new Uint8Array(1)
      )[0] &
        (15 >> (c / 4)))
    ).toString(16);
  });
};
watch(()=> props.uploadCancelEvent,(val)=>{
    if(val){
        document.getElementById("preview-template").innerHTML = ""
        tempImageUploading = []
        imageUploadList.value = []
        listAllUploadImage.value = []
        currentImgPreviewIndex.value = null
        tempImage_length.value = 0
        tempImage.value = []
    }
})
</script>

<style lang="scss">
#imageDesc {
    .modal-dialog{
        max-width: 500px;
        overflow-y: auto;
    }
    .modal-body{
        padding: 20px;
    }
    .dz-preview{
        &:hover {
            background: unset;
        }
        .dz-details {
            padding-right: 0;
        }
    }
}
.dropzone {
    padding: 0 !important;
    // border-color: #DDD !important;
    // border-style: solid !important;
    // --tw-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
    // box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    .dz-preview .dz-progress{
        border: 3px solid rgb(20 45 113) !important;
        background: rgba(255,255,255,0.6) !important;
    }
}
.dz-preview {
    position: relative;
    display: inline-block;
    vertical-align: top;
    // margin: 16px;
    // min-height: 100px;
    display: flex;
    // width: 100%;
    &.dz-image-preview {
        // background: white;
        .dz-details {
            transition: opacity .2s linear;
        }
    }
    &:hover {
        background: #efefef;
    }
    .dz-image {
        flex: 0 0 auto;
        border-radius: 6px;
        overflow: hidden;
        width: 85px;
        height: 85px;
        position: relative;
        display: block;
        z-index: 10;
        background: #ddd;
        cursor: pointer;
        @media (max-width: 480px) {
            width: 60px;
            height: 60px;
        }
        @media (min-width: 481px) and (max-width: 1023px) {
            width: 70px;
            height: 70px;
        }
        img{
            height: 100%;
            width: 100%;
            object-fit: cover;
        }
    }

    .dz-details {
        margin-left: 5px;
        width: 100%;
        padding-right: 30px;
        .image-description{
            display: -webkit-box;
            -webkit-line-clamp: 2;
            overflow: hidden;
            -webkit-box-orient: vertical;
        }
    }
    // .dz-details {
    //     z-index: 20;
    //     position: absolute;
    //     top: 0;
    //     left: 0;
    //     opacity: 0;
    //     font-size: 13px;
    //     min-width: 100%;
    //     max-width: 100%;
    //     padding: 2em 1em;
    //     text-align: center;
    //     color: #000000e6;
    //     line-height: 150%;
    //     .dz-size {
    //         margin-bottom: 1em;
    //         font-size: 16px;
    //     }
    //     .dz-filename{
    //         white-space: nowrap;
    //         &:not(:hover) {
    //             overflow: hidden;
    //             text-overflow: ellipsis;
    //             span {
    //                 border: 1px solid transparent;
    //             }
    //         }
    //     }
    //     .dz-filename span, .dz-size span {
    //         background-color: #fff6;
    //         padding: 0 0.4em;
    //         border-radius: 3px;
    //     }
    // }
    .dz-progress {
        opacity: 1;
        z-index: 1000;
        pointer-events: none;
        position: absolute;
        height: 16px;
        left: 50%;
        top: 50%;
        margin-top: -8px;
        width: 80px;
        margin-left: -40px;
        background: rgba(255,255,255,.9);
        -webkit-transform: scale(1);
        border-radius: 8px;
        overflow: hidden;
        border: 3px solid rgb(20, 45, 113) !important;
        background: rgba(255,255,255,0.6) !important;
        @media (max-width: 480px) {
            width: 55px;
            margin-left: -27px;
        }
        @media (min-width: 481px) and (max-width: 1023px) {
            width: 60px;
            margin-left: -30px;
        }
        .dz-upload {
            background: #FFF;
            background: linear-gradient(to bottom,rgb(104, 136, 223),rgb(104, 117, 152));
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            width: 0;
            transition: width .3s ease-in-out;
        }
    }
    &.dz-processing .dz-progress {
        opacity: 1;
        transition: all .2s linear;
    }
    &.dz-complete .dz-progress {
        opacity: 0;
        transition: opacity .4s ease-in;
    }
    .dz-error-message {
        pointer-events: none;
        z-index: 1000;
        position: absolute;
        display: block;
        display: none;
        opacity: 0;
        transition: opacity .3s ease;
        border-radius: 8px;
        font-size: 13px;
        top: 130px;
        left: -10px;
        width: 140px;
        background: #be2626;
        background: linear-gradient(to bottom,#be2626,#a92222);
        padding: 0.5em 1.2em;
        color: #fff;
    }
    &.dz-success .dz-success-mark {
        -webkit-animation: passing-through 3s cubic-bezier(.77,0,.175,1);
        animation: passing-through 3s cubic-bezier(.77,0,.175,1);
    }
    .dz-success-mark, .dz-error-mark {
        pointer-events: none;
        opacity: 0;
        z-index: 500;
        position: absolute;
        display: block;
        top: 50%;
        left: 50%;
        margin-left: -27px;
        margin-top: -27px;
        color: #FFF;
        span,i {
            display: block;
            width: 45px;
            height: 45px;
        }
    }
    .image-remove{
        position: absolute;
        right: 0;
        top: 0;
        padding: 5px;
        width: 30px;
        height: 30px;
        opacity: 0.6;
        cursor: pointer;
        &:hover{
            opacity: 1;
        }
    }
    
}
#error-table{
    font-size: 14px;
    max-width: 100%;
    width: 100%;
    &,th, td {
        border: 1px solid #ddd;
    }
    td, th{
        padding: 5px;
    }
    tbody{
        text-align: left;
    }
}
</style>